import IconButton from "@mui/material/IconButton"
import { styled } from "@mui/system"

export const CloseWrapper = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.darkest,
  borderRadius: "100%"
}))
